/* Where you have been. See sv-recent.liquid for why.

   THE CAP IS TWELVE and the storage is one key. A shopper browsing a 3,500
   product store in one sitting can easily open forty things; keeping forty
   handles makes the row a second catalogue to scroll, which is the problem it
   was built to solve, not the solution. Twelve is two rows on a phone.

   EVERY READ AND WRITE IS WRAPPED. localStorage throws in a private window on
   some browsers and returns null when site data is cleared, and a product page
   that fails to render because it could not remember itself is a worse bug
   than not remembering. */
(function () {
  var KEY = 'sv.seen.v1';
  var CAP = 12;

  function read() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string'; }) : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, CAP))); }
    catch (e) { /* private window, cleared data, quota: not worth a failure */ }
  }

  function remember(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function thumb(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function draw(root) {
    var row = root.querySelector('[data-recent-row]');
    var here = (document.body.getAttribute('data-sv-handle') || '');
    var list = read().filter(function (h) { return h !== here; });
    if (!list.length || !row) return;

    /* Fetch them all, then draw ONCE in the stored order. Drawing each card as
       its fetch lands puts them on the page in whatever order the network
       returned, which is not the order the shopper looked at them in, and that
       is the whole point of the row. */
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var html = items.filter(Boolean).map(function (j) {
        var img = (j.featured_image || (j.images && j.images[0]) || '');
        return '<a class="sv-recent__c" href="/products/' + esc(j.handle) + '">' +
               (img ? '<img src="' + esc(thumb(img, 300)) + '" alt="" loading="lazy" width="300" height="300">'
                    : '<span class="sv-recent__noimg"></span>') +
               '<span class="sv-recent__t">' + esc(j.title) + '</span>' +
               '<span class="sv-recent__p">' + money(j.price) + '</span></a>';
      }).join('');
      if (!html) return;
      row.innerHTML = html;
      root.hidden = false;
    });
  }

  function boot() {
    var h = document.body.getAttribute('data-sv-handle');
    if (h) remember(h);
    document.querySelectorAll('[data-sv-recent]').forEach(function (root) {
      var c = root.querySelector('[data-recent-clear]');
      if (c) {
        c.addEventListener('click', function () {
          write([]); root.hidden = true;
        });
      }
      draw(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
}());
